export const BODY_GRID_AREA = 'body';
export const TOP_BAR_GRID_AREA = 'top-bar';
export const SIDEBAR_GRID_AREA = 'sidebar';

export const TEMPLATE_AREA = `
  "${TOP_BAR_GRID_AREA}"
  "${BODY_GRID_AREA}"
`;

export const TEMPLATE_AREA_WITH_SIDEBAR = `
  "${TOP_BAR_GRID_AREA} ${TOP_BAR_GRID_AREA}"
  "${BODY_GRID_AREA} ${SIDEBAR_GRID_AREA}"
`;
